import { render, staticRenderFns } from "./SkinThemeTab.vue?vue&type=template&id=dc61fbda&scoped=true"
import script from "./SkinThemeTab.vue?vue&type=script&lang=js"
export * from "./SkinThemeTab.vue?vue&type=script&lang=js"
import style0 from "./SkinThemeTab.vue?vue&type=style&index=0&id=dc61fbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc61fbda",
  null
  
)

export default component.exports